export enum PlatformId {
  Android = "android",
  IOS = "ios",
  Web = "web",
  China = "china",
}

export const ALL_PLATFORMS: string[] = Object.values(PlatformId);

export const isPlatformId = (platform: string): platform is PlatformId =>
  ALL_PLATFORMS.includes(platform.toLowerCase() as PlatformId);

// This data is duplicated in the backend, but adding here minimizes the number of requests needed to render the release page.
export const platformNames: Record<PlatformId, string> = {
  [PlatformId.Android]: "Android",
  [PlatformId.China]: "China Android",
  [PlatformId.IOS]: "iOS",
  [PlatformId.Web]: "Web",
};

export const CHINA_STORES = ["Huawei", "Oppo", "Tencent", "Vivo", "Xiaomi"];
